import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

export const getDimensions = () => axios.get(`${API}/dimensions`).then((r) => r.data);
export const getReleases = (type) =>
  axios.get(`${API}/releases`, { params: type ? { releaseType: type } : {} }).then((r) => r.data);
export const getFeatured = () => axios.get(`${API}/releases/featured`).then((r) => r.data);
export const getRelease = (slug) => axios.get(`${API}/releases/${slug}`).then((r) => r.data);
export const getVisuals = () => axios.get(`${API}/visuals`).then((r) => r.data);
export const subscribe = (payload) =>
  axios.post(`${API}/subscribers`, payload).then((r) => r.data);

export const getStoreProducts = (params) => axios.get(`${API}/store/products`, { params }).then((r) => r.data);
export const getStoreCategories = () => axios.get(`${API}/store/categories`).then((r) => r.data);
export const validatePromo = (payload) => axios.post(`${API}/store/promo/validate`, payload).then((r) => r.data);
export const createCheckout = (items, promoCode) =>
  axios
    .post(`${API}/payments/checkout`, { items, origin_url: window.location.origin, promo_code: promoCode || null })
    .then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

export const money = (cents, currency = "usd") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency }).format((cents || 0) / 100);

export const authRegister = (payload) => axios.post(`${API}/auth/register`, payload).then((r) => r.data);
export const authLogin = (payload) => axios.post(`${API}/auth/login`, payload).then((r) => r.data);
export const authLogout = () => axios.post(`${API}/auth/logout`).then((r) => r.data);
export const authMe = () => axios.get(`${API}/auth/me`).then((r) => r.data);
export const getAccountOrders = () => axios.get(`${API}/account/orders`).then((r) => r.data);
export const authForgotPassword = (payload) => axios.post(`${API}/auth/forgot-password`, payload).then((r) => r.data);
export const authChangePassword = (payload) => axios.post(`${API}/auth/change-password`, payload).then((r) => r.data);
export const authChangeEmail = (payload) => axios.post(`${API}/auth/change-email`, payload).then((r) => r.data);
export const confirmEmailChange = (payload) => axios.post(`${API}/auth/confirm-email-change`, payload).then((r) => r.data);
export const pendingEmailChange = () => axios.get(`${API}/auth/email-change/pending`).then((r) => r.data);
export const resendEmailChange = () => axios.post(`${API}/auth/email-change/resend`).then((r) => r.data);
export const cancelEmailChange = () => axios.post(`${API}/auth/email-change/cancel`).then((r) => r.data);
export const authResetPassword = (payload) => axios.post(`${API}/auth/reset-password`, payload).then((r) => r.data);
export const getVault = () => axios.get(`${API}/account/vault`).then((r) => r.data);
export const requestVaultDownload = (payload) => axios.post(`${API}/account/vault/download`, payload).then((r) => r.data);
export const updatePreferences = (payload) => axios.patch(`${API}/account/preferences`, payload).then((r) => r.data);

export const getActiveWhispers = () => axios.get(`${API}/whispers/active`).then((r) => r.data);
export const getHomepage = (preview = false) => axios.get(`${API}/homepage${preview ? "?preview=true" : ""}`).then((r) => r.data);
export const getPublicSettings = () => axios.get(`${API}/settings/public`).then((r) => r.data);
export const getMyNetwork = () => axios.get(`${API}/network/me`).then((r) => r.data);
export const getShareables = () => axios.get(`${API}/network/shareables`).then((r) => r.data);
export const membershipStatus = () => axios.get(`${API}/membership/status`).then((r) => r.data);
export const membershipCheckout = (payload) => axios.post(`${API}/membership/checkout`, payload).then((r) => r.data);
export const membershipConfirm = (payload) => axios.post(`${API}/membership/confirm`, payload).then((r) => r.data);
export const membershipCancel = () => axios.post(`${API}/membership/cancel`).then((r) => r.data);
export const supporterMe = () => axios.get(`${API}/supporter/me`).then((r) => r.data);
export const submitSupporter = (payload) => axios.post(`${API}/supporter/profile`, payload).then((r) => r.data);
export const getSupporters = () => axios.get(`${API}/supporters`).then((r) => r.data);
export const getMyDimensions = () => axios.get(`${API}/account/dimensions`).then((r) => r.data);
export const getMyCollection = () => axios.get(`${API}/account/collection`).then((r) => r.data);
export const verifyEmailToken = (payload) => axios.post(`${API}/auth/verify-email`, payload).then((r) => r.data);
export const resendVerification = () => axios.post(`${API}/auth/resend-verification`).then((r) => r.data);
export const authorizeAudio = (payload) => axios.post(`${API}/audio/authorize`, payload).then((r) => r.data);
export const getHero = () => axios.get(`${API}/hero`).then((r) => r.data);
export const getTrackPage = (slug) => axios.get(`${API}/tracks/${slug}`).then((r) => r.data);
export const getCompleteSet = () => axios.get(`${API}/store/complete-set`).then((r) => r.data);
export const dvStatus = () => axios.get(`${API}/dimension-v/status`).then((r) => r.data);
export const dvRedeem = (code) => axios.post(`${API}/dimension-v/redeem`, { code }).then((r) => r.data);
export const dvContent = () => axios.get(`${API}/dimension-v/content`).then((r) => r.data);
export const adminListWhispers = () => axios.get(`${API}/admin/whispers`).then((r) => r.data);
export const adminCreateWhisper = (payload) => axios.post(`${API}/admin/whispers`, payload).then((r) => r.data);
export const adminUpdateWhisper = (id, payload) => axios.patch(`${API}/admin/whispers/${id}`, payload).then((r) => r.data);
export const adminDeleteWhisper = (id) => axios.delete(`${API}/admin/whispers/${id}`).then((r) => r.data);
export const adminVaultNotify = (payload) => axios.post(`${API}/admin/vault/notify`, payload).then((r) => r.data);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const PHRASES = [
  "Music is only the first dimension.",
  "Not everything exists in one dimension.",
  "One universe. Many dimensions.",
  "Every motion carries meaning.",
  "Reality has layers.",
  "What you see is only one dimension.",
];
